import React from 'react';
import { FormAsyncMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useTagsFilter } from './useTagsFilter';

export const TagsFilter = ({ value, setFilters, sharedList, orderBy }) => {
  const { formSchema, defaultOptions, isLoading, onSearchChange, onSubmit, onMenuOpen } = useTagsFilter({
    sharedList,
    orderBy,
    setFilters,
  });

  return (
    <Formik initialValues={{ tags: value || [] }} validationSchema={formSchema} onSubmit={onSubmit} enableReinitialize>
      <Form>
        <FormikAutoSubmit />
        <Field
          name="tags"
          label="Tags"
          placeholder="Add..."
          size="small"
          component={FormAsyncMultiSelect}
          loadOptions={onSearchChange}
          defaultOptions={defaultOptions}
          onMenuOpen={onMenuOpen}
          isLoading={isLoading}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

TagsFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
  sharedList: PropTypes.object,
  orderBy: PropTypes.oneOf(['count', 'alpha']),
};

TagsFilter.defaultProps = {
  value: [],
  sharedList: null,
  orderBy: 'alpha',
};
